import React from 'react';
import {useRouteMatch} from 'react-router-dom';
import ButtonShowModal from 'common/components/ButtonShowModal';
import deleteIcon from 'common/assets/close_button.svg';
import {pathnames as P} from 'common/constants/pathnames';
import styles from './styles.module.scss';

const ButtonDeleteFile = ({
                            fileName,
                            fileID,
                            deleteFile,
                            getFileList,
                          }) => {
  const {params: {shumaId}} = useRouteMatch(P.INSPECTION_AND_FORM_IDS);
  const handleDeleteFile = () => {
    deleteFile({shumaId, fileID})
      .then(() => getFileList({shumaId}));
  };

  return (
    <ButtonShowModal
      label={
        <img
          src={deleteIcon}
          alt="delete"
          className={styles.icon}
        />
      }
      buttonClassName={styles.buttonDelete}
      pathname={`delete-${fileID}`}
    >
      {({closeModal}) => {
        return (
          <div className={styles.deleteModal}>
            <h2 className={styles.title}>אישור הסרת קובץ</h2>
            <div className={styles.text}>
              האם אתה בטוח שברצונך להסיר את קובץ ' <span>{fileName}</span>'?
            </div>
            <div className={styles.buttons}>
              <button
                onClick={e => {
                  e.preventDefault();
                  closeModal();
                }}
                className={`${styles.actionBtn} ${styles.actionCancel}`}
              >
                ביטול
              </button>
              <button
                onClick={e => {
                  e.preventDefault();
                  handleDeleteFile();
                  closeModal();
                }}
                className={`${styles.actionBtn} ${styles.actionDelete}`}
              >
                אישור
              </button>
            </div>
          </div>
        );
      }}
    </ButtonShowModal>
  );
};

export default ButtonDeleteFile;